import React from 'react';
/**
 * Skeleton component for a Toolbar Node.
 */
export function ToolbarNodeSkeleton() {
    return (React.createElement("div", { className: "toolbar-node-skeleton-wrapper" },
        React.createElement("div", { "aria-hidden": "true", className: "toolbar-node-skeleton" })));
}
